import { Text, UnstyledButton, useMantineTheme } from '@mantine/core';
import React from 'react';

import { CardBrand, CurrencyCode, PaymentMethodEnum } from '@portals/types';
import { formatCurrency } from '@portals/utils';

import { ReactComponent as PurchaseOrderLogo } from '../../assets/img/po.svg';
import { CreditCardLogo } from '../CreditCardLogo';
import { DetailsList, DetailsListProps } from '../details-list/DetailsList';

interface InvoicePaymentDetailsProps {
  payment_method: string;
  credit_card: { last_4_digits: string; brand: CardBrand };
  tax: number;
  currency: CurrencyCode;
  amount: number;
  onOpenPurchaseOrderPanel: () => void;
}

export function InvoicePaymentDetails({
  payment_method,
  credit_card,
  amount,
  tax,
  currency,
  onOpenPurchaseOrderPanel,
}: InvoicePaymentDetailsProps) {
  const theme = useMantineTheme();

  const detailsList: DetailsListProps['items'] = [
    {
      label:
        payment_method === PaymentMethodEnum.CreditCard ? (
          <CreditCardLogo brand={credit_card?.brand} />
        ) : (
          <PurchaseOrderLogo />
        ),
      value:
        payment_method === PaymentMethodEnum.CreditCard ? (
          <Text>•••• {credit_card?.last_4_digits}</Text>
        ) : (
          <UnstyledButton onClick={onOpenPurchaseOrderPanel}>
            <Text color={theme.colors.blue_accent[4]}>Show purchase order</Text>
          </UnstyledButton>
        ),
    },
    { label: 'Tax', value: formatCurrency(tax, currency) },
    {
      label: 'Total Charged',
      value: formatCurrency(amount, currency),
    },
  ];

  return <DetailsList title="Payment" items={detailsList} />;
}
